import React, { useMemo, useState } from "react";
import { Modal } from "../../Modal";
import { GenericFormContext } from "../GenericFormContext";
/**
 * ## Description
 *
 * A wrapper around the Iceberg Modal component that provides context and other setup
 * for containing a form.
 * A complex element, composed of some other components (body and footer),
 * that opens a modal wrapping the children (usually a Form) around a Context.Provider to
 * handle passing props down (ie. editIsAllowed).
 */
export const FormModal = (props) => {
    const { modalId, widgetName, isOpen, title, closeModal, children } = props;
    const [submissionError, setSubmissionError] = useState("");
    const contextValue = useMemo(() => ({ closeFormFn: closeModal, editIsAllowed: true, setSubmissionError, submissionError }), [closeModal, submissionError]);
    return (React.createElement(Modal
    // We are using id for tracking and analytics
    , { "data-trackid": modalId, "data-widget-name": widgetName, "data-widget-type": "Modal" // Hard-coding it as props.widgetType will be FormBody and we need to find the def in the defs_modals file.
        , "z-index": 1200, open: isOpen, title: title, onClose: closeModal, minWidth: [0, "600px"], width: ["420px", "600px"], margin: "18px" },
        React.createElement(GenericFormContext.Provider, { value: contextValue }, children)));
};
